import { BaseEntity } from 'src/app/tools/models/baseEntity'
import { PriceList } from './price-list-entity';
import { Product } from './product-entity';

export class PriceListLineDetail extends BaseEntity {
    priceList           : PriceList;
    priceListLineNumber : number;
    product             : Product;
    salesPrice          : number;
    returnPrice         : number;
}